<div class="nb-theme-default">
<nb-layout>

  <!-- <nb-layout-header fixed> -->
  <!-- Insert header here -->
  <!-- </nb-layout-header> -->

  <nb-layout-column>
    <slot>
      <!-- <nbx-tree-table [addCheckboxes]="addcheckbox" custom-column='Attributes' columns='["Mobile Universe", "Risk Score (Top 1-5%)", "Risk Score (Top 6-10%)"]'
      [datajson]="profileData" [expandall]="expandAll" [collapseall]="collapseAll"></nbx-tree-table> -->
    
      <!-- <nbx-toastr></nbx-toastr> -->
      <!-- <nbx-button (click)="dosome('expand')">Toggle checkbox</nbx-button>
      <nbx-button (click)="dosome('collapse')">Toggle checkbox</nbx-button> -->
      <!-- <input type="text" #jsonval (change)="getjson(jsonval.value)"> -->
      <!-- <nbx-waterfall [resizable]="resizable"></nbx-waterfall> -->
      <!-- <nbx-stack-echart [resizable]="resizable"></nbx-stack-echart> -->
      <!-- <nbx-line-echart [resizable]="resizable"></nbx-line-echart> -->
      <!-- <nbx-sankey-echart [resizable]="resizable"></nbx-sankey-echart> -->
      <!-- <nbx-pie-echart [tooltipstr]="tooltip"></nbx-pie-echart> -->
      <!-- <nbx-barchart [resizable]="resizable"></nbx-barchart> -->
      <!-- <nbx-radar-echart></nbx-radar-echart> -->
      <!-- <nbx-input></nbx-input> -->
      <!-- <nbx-file-upload [validext]="validExt" ></nbx-file-upload> -->
      <!-- <nbx-button [showtoastr]="showtoastr" title='The title of Notification'
      message='This is the message'
      toaststatus='danger'></nbx-button> -->
      <!-- <nbx-tree-table ></nbx-tree-table> -->
      <!-- <nbx-card></nbx-card> -->
      <!-- <nbx-select></nbx-select> -->
      <!--<nbx-checkbox></nbx-checkbox>-->
      <!--<nbx-radio [options]="opts"></nbx-radio>-->
      <!-- <nbx-slider [max]='50'></nbx-slider> -->
      <!--<nbx-stepper></nbx-stepper>-->
      <!-- <input #urlval type="text" placeholder="url" (change)="getUrl(urlval.value)">
      <nbx-table [apiUrl]=apiUrl></nbx-table> -->
      <!-- <nbx-datepicker></nbx-datepicker> -->
    </slot>
  </nb-layout-column>

  <!-- <nb-layout-footer fixed> -->
  <!-- Insert footer here -->
  <!-- </nb-layout-footer> -->

</nb-layout>
</div>
